import { Control, useController } from 'react-hook-form';
import { Choice } from '@viome/viome-base/src/usecase/Questionnaire/Questionnaire.model';
import { Card, CardContent } from '@design-system/Card';
import { Label } from '@/components/design-system/Label';
import {
  RadioGroup,
  RadioGroupItem,
} from '@/components/design-system/radio-group';
import { cn } from '@/utils/styles';

interface Props {
  control: Control<Record<string, unknown>>;
  name: string;
  title: string;
  subtitle?: string;
  options: Choice[];
  required?: boolean;
  disabled?: boolean;
}

const RadioButtonWrapper: React.FC<Props> = ({
  control,
  name,
  options,
  required = false,
  disabled = false,
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: {
      required: required ? 'Please select an option' : false,
    },
  });

  return (
    <div className="w-full">
      <Card className="border-transparent bg-transparent">
        <CardContent className="p-0">
          <RadioGroup
            value={field.value as string}
            onValueChange={field.onChange}
            disabled={disabled}
          >
            {options?.map((option) => (
              <Label
                key={option.value}
                htmlFor={`${name}-${option.value}`}
                className={cn(
                  'text-base cursor-pointer bg-white flex items-center justify-between mb-4 p-4 rounded-[32px] border border-[#E5E7EB]',
                  field.value === option.label && 'border-2 border-[#146464]',
                  disabled && 'opacity-50 cursor-not-allowed',
                )}
              >
                <span className="typography-btn-large text-[#111827]">
                  {option.label}
                </span>
                <RadioGroupItem
                  value={option.label}
                  id={`${name}-${option.value}`}
                  disabled={disabled}
                />
              </Label>
            ))}
          </RadioGroup>
          {error && <p className="text-red-500 mt-2">{error.message}</p>}
        </CardContent>
      </Card>
    </div>
  );
};

export default RadioButtonWrapper;
